import React, { FC } from 'react';

import { TModalComponentsListProps } from '../../types/productSeriesDetailFeature.types';
import InnerSplitModule from './innerSplitModule';
import './styles.scss';

const InnerSplitModules: FC<TModalComponentsListProps> = (props) => {
  const model = props.components;

  return (
    <section className="inner-split-modules">
      {model?.map((component) => (
        <InnerSplitModule backgroundColor={props.backgroundColor} component={component} key={component?.id} />
      ))}
    </section>
  );
};

export default InnerSplitModules;
